import { Pipe, PipeTransform } from '@angular/core';
import { MobileOrderViewModel } from '../viewModels/mobileData.viewModel';

@Pipe({
  name: 'OrderselectionFilter',
  standalone: false,
})
export class OrderselectionFilterPipe implements PipeTransform {
  transform(orders: MobileOrderViewModel[], filterText: string): MobileOrderViewModel[] {
    if (!orders) {
      return [];
    }
    if (!filterText) {
      return orders;
    }
    filterText = filterText.toLowerCase();
    return orders.filter((order) => {
      return order.designation.toLowerCase().includes(filterText);
    });
  }
}
